<template>
  <div class="box">

    <div class="product" id="product">
      <header>
        <nav>
          <a href="#product">Beranda</a>
          <a href="#features">Fitur</a>
          <a href="#how">Cara kerjanya</a>
          
          <a href="#privacy">Kebijakan Privasi</a>
          <a href="#about">Tentang kami</a>
        </nav>
      </header>
      <p class="logoname"> Kekurangan Uang ? </p>
      <p class="logomsg"> PT.RupiahKilat Indonesia adalah badan usaha yang mempunyai beberapa anggota perseorangan yang bersifat terbuka atau sukarela,RupiahKilat adalah produk PT.RupiahKilat Indonesia yang khusus digunakan untuk memberikan pinjaman online berbunga rendah kepada anggota.Kami berkomitmen bahwa produk pinjaman kami akan memenuhi kebutuhan keuangan dan menjaga keamanan data Anda!</p>
      <!-- <a href="https://play.google.com/store/apps/details?id=com.cepat.untung" class="googlelogo"></a> -->
    </div>
    <div class="features" id="features">
      <h2 class="title">Fitur</h2>
      <div class="cards">
        <div class="card">
          <img class="ball" src="../assets/testlimit.png" alt="">
          <h5>★Sangat dapat diandalkan</h5>
          <p>PT.RupiahKilat Indonesia telah disahkan oleh Kementrian Koperasi dan Usaha Kecil dan Menengah</p>
        </div>
        <div class="card">
          <img class="ball" src="../assets/praktis.png" alt="">
          <h5>★Produk pinjaman banyak</h5>
          <p>Pilihan banyak hingga 100 pilihan</p>
        </div>
        <div class="card">
          <img class="ball" src="../assets/lengkap.png" alt="">
          <h5>★Layanan luas</h5>
          <p>Dimanapun Anda berada di Indonesia, anggota dapat menggunakan aplikasi RupiahKilat</p>
        </div>
      </div>
    </div>
    <div class="how" id="how">
      <h2 class="title">Cara kerjanya ?</h2>
      <div class="howBox">
        <div class="left">
          <div class="item">
            <p>1. Mendaftar sebagai anggota PT.RupiahKilat Indonesia</p>
          </div>
          <div class="item">
            <p>3. Anggota mengisi informasi dasar </p>
          </div>
        </div>

        <div class="right">
          <div class="item">
            <p>2. Proses evaluasi kredit pengguna secara komprehensif</p>
          </div>
          <div class="item">
            <p>4. Menunggu pinjaman dicairkan ke rekening Anda</p>
          </div>
        </div>
        <div class="middle"></div>
      </div>

    </div>
    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">
          Menggunakan fungsi penghapusan data, demi keamanan data Anda, Anda
          perlu memverifikasi identitas Anda
        </div>
        <div class="title">Silakan masukkan nomor ponsel Anda</div>
        <input
          v-model="mobile"
          type="text"
          class="tel-in"
          placeholder="Silakan masukkan nomor telepon"
        />
        <input
          v-model="password"
          type="password"
          class="tel-pa"
          placeholder="Silakan masukkan kata sandi APLIKASI"
        />
        <div class="btn" @click="delSearch">Langkah berikutnya</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="text-box">
          Pengguna Yang Dihormati
          <br />
          Halo! Terima kasih banyak telah memilih untuk menggunakan DanaBerlari APP. <br />
          Sebelum mengajukan penghapusan akun, pastikan semua pesanan Anda
          telah diselesaikan dan tidak ada pesanan yang sedang ditinjau. Perlu
          dicatat bahwa setelah akun dihapus, data tidak dapat dipulihkan.
          Harap konfirmasi dengan cermat sebelum beroperasi. APP ini tidak
          bertanggung jawab atas segala kerugian yang terjadi pada properti
          pribadi. <br />
          Jika Anda sudah mengkonfirmasi ingin menghapus data Anda, silakan
          klik tombol di bawah ini.
        </div>
        <div class="btn" @click="candelete">konfirmasi hapus</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">
          Silakan masukkan kode verifikasi untuk memverifikasi identitas Anda
        </div>
        <div class="iump-box">
          <input
            v-model="code"
            type="text"
            class="car-in tel-in"
            placeholder="Silakan masukkan kode verifikasi 4 digit"
          />
          <div class="count-btn" @click="Reenviar">
            {{ Time <= 0 ? "Kirim ulang" : Time }}
          </div>
        </div>
        <div class="btn" @click="doDelete">Oke</div>
      </div>

      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="" />
        <p>Data Anda telah dihapus!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">Verifikasi kartu identitas</div>
        <input
          v-model="idcard"
          type="text"
          class="tel-in"
          placeholder="Silakan masukkan Nomor KTP Anda"
        />
        <div class="btn" @click="verifyIdCard">Memeriksa</div>
      </div>
    </div>


    <div class="flex-box" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img" />
          {{ msg }}
        </div>
        <img
          src="../assets/close.png"
          class="close"
          @click="msgDlg = false"
        />
      </div>
    </div>
    <privacy ></privacy>
    <div class="about" id="about">
      <h2 class="title">Tentang kami</h2>
      <p>
        Fokus utama RupiahKilat adalah membantu anggota dalam menyelesaikan masalah keuangan mereka sehingga anggota tidak perlu menghabiskan banyak waktu dan rumit untuk mendapatkan dana yang dibutuhkan.RupiahKilat adalah produk PT.RupiahKilat Indonesia yang khusus digunakan untuk memberikan pinjaman online berbunga rendah kepada anggota.PT.RupiahKilat Indonesia telah disahkan oleh Kementrian Koperasi dan Usaha Kecil dan Menengah.
      </p>
    </div>
    <footer class="bottom">
      <!-- <p><img class="ksp" src="../assets/ksp.png" alt=""></p> -->
      <p><img class="address" src="../assets/address.png" alt="">Jl. Bugis Jl. Kb. Bawang XV B No.1, RT.19/RW.2, Kb. Bawang, Tj. Priok, Kota Jkt Utara, <br> Daerah Khusus Ibukota Jakarta 14320</p>
      <p><img class="email" src="../assets/email.png" alt="">EPearson19790103@gmail.com</p>
   
    </footer>
    <footer class="end">
      PT.RupiahKilat Indonesia © 2024 All Rights Reserved
    </footer>
  </div>
</template>
<script>
import privacy from "@/components/privacy";
import * as api from "@/api/api";
export default {
  name: 'App',
  components: {
    privacy
  },
  data () {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      show: false,
      mobile: "",
      password: "",
      code: "",
      msgDlg: false,
      msg: "",
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: "",
      verifyIDCard: "",
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    choiceMenu (index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step").scrollIntoView(); break;
        case 2: document.getElementById("product").scrollIntoView(); break;
        case 3: document.getElementById("user").scrollIntoView(); break;
        case 4: document.getElementById("about").scrollIntoView(); break;
        case 5: document.getElementById("privacy").scrollIntoView(); break;
        case 6: document.getElementById("footer").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick () {
      this.showMenu = !this.showMenu
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password,
      };

      if (!this.mobile) {
        this.msgDlg = true;
        this.msg = "Nomor ponsel tidak boleh kosong.";
        return;
      }
      if (!this.password) {
        this.msgDlg = true;
        this.msg = "Kata sandi wajib diisi.";
        return;
      }

      console.log(this.$loading);
      let loding = this.$loading.show({});
      api
        .delInfoSearch(data)
        .then((res) => {
          loding.hide();
          this.infoData = res.data;
          this.steps = 2;
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id,
      };
      let loding = this.$loading.show({});
      api
        .delInfoCanDelete(data)
        .then((res) => {
          loding.hide();
          if (res.data.idcard) {
            this.verifyIDCard = res.data.idcard;
            this.steps = 5;
          } else {
            this.steps = 3;
            this.Reenviar();
          }
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3;
        this.Reenviar();
      } else {
        this.msgDlg = true;
        this.msg = "Kartu ID yang dimasukkan salah dan verifikasi gagal.";
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return;
      }
      this.Countdown(60);
      let data = {
        mobile: this.mobile,
      };
      let loding = this.$loading.show({});
      api
        .delInfoSms(data)
        .then((res) => {
          loding.hide();
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    doDelete() {
      let loding = this.$loading.show({});
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id,
      };
      api
        .delInfoDoDelete(data)
        .then((res) => {
          loding.hide();
          this.steps = 4;
        })
        .catch((e) => {
          loding.hide();
          this.msgDlg = true;
          this.msg = e.message;
        });
    },
    Countdown(time) {
      this.Time = time;
      if (time <= 0) {
        return;
      }

      setTimeout(() => {
        this.Countdown(time - 1);
      }, 1000);
    },
  
  }
}
</script>


<style lang="less" >
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
